import { useNavigate } from "react-router";
import ResizeListener from "../../../utility/ResizeListener";
import BodyComponent from "../../components/BodyComponent";
import TopHeaderComponent from "../../components/TopHeaderComponent";
import { WHITE_COLOR } from "../../resources/colorsManager";
import Graph from "./Graph";
import RecentTransaction from "./RecentTransaction";
function TransactionCenter() {
  const { width, height } = ResizeListener();
  const navigate = useNavigate();
  return (
    <BodyComponent style={{ width: "100%" }}>
      <TopHeaderComponent
        headerName="Business Intelligence"
        isSearchRequired={false}
        inputStyle={{
          width: width * 0.3,
          minWidth: 300,
        }}
        placeholder="Search Transaction ID...."
        onClickBack={() => {
          navigate(-1);
        }}
        showFilter={false}
        showDownload={false}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          backgroundColor: WHITE_COLOR,
          marginTop: 20,
          borderRadius: 15,
          padding: 20,
          flexDirection: width > 1000 ? "row" : "column",
          height: width > 1000 ? "auto" : "100%",
        }}
      >
        <Graph width={width} height={height} />
        <RecentTransaction width={width} height={height} />
      </div>
    </BodyComponent>
  );
}

export default TransactionCenter;
